// Store
import Vue from 'vue';
import EventBus from '../../EventBus';

// State
// ....
const state = {
  data: ''
}

// Getters
// ...
const getters = {
  getData: (state) => state.data
}

// Mutations
// ...
const mutations = {
  setData: (state, payload) => state.data = payload
}


// Actions
// ...
const actions = {
  fetchData(state) {
    EventBus.$emit('ocupado', true);
    Vue.http.get(`http://${RRHH_HOST}/nivel-estudio`)
    .then(response => response.json())
    .then(json => {
      this.commit('nivel_estudio/setData', json)
      EventBus.$emit('ocupado', false);
    }, (reason) => console.log(reason));
  }
}



// Export store
// ...
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modulos/NivelEstudio.js